import { inject, Service } from '@angular/core';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { SystemMessageType } from '@portal-core/system-messages/enums/system-message-type.enum';
import { SystemMessage } from '@portal-core/system-messages/models/system-message.model';
import { SystemMessagesDataService } from '@portal-core/system-messages/services/system-messages-data.service';
import { UsersService } from '@portal-core/users/services/users.service';
import { Resettable } from '@portal-core/util/resettable.decorator';
import { Observable, map, tap } from 'rxjs';

@Service()
@Resettable()
export class SystemMessagesService extends CollectionServiceBase<SystemMessage> {
  private readonly usersService = inject(UsersService);

  constructor() {
    super(inject(SystemMessagesDataService));
  }

  whatsNewMessage: SystemMessage = {
    Id: 'whats-new',
    Message: 'We\'ve made some improvements. Check out what we\'ve been up to!',
    Title: 'What\'s New!',
    Type: SystemMessageType.WhatsNew,
    Url: 'https://documentation.madcapsoftware.com/central/Default.htm#cshid=Whats_New'
  };

  getWhatsNewMessage$(): Observable<SystemMessage> {
    return this.usersService.getWhatsNew$().pipe(
      map(response => {
        if (response.Result === 'True') {// response.Result is either 'True' or 'False'
          return this.whatsNewMessage;
        }
      }),
      tap(message => {
        if (message) {
          this.addItems$([message]);
        }
      })
    );
  }

  updateLatestAppVersionViewed$(): Observable<void> {
    return this.usersService.updateLatestVersionViewed$().pipe(
      tap(() => this.removeItems$([this.whatsNewMessage.Id]))
    );
  }
}
